import React from "react";
import { Row, Col, Button, Table } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

export default function FeedbackDashboard({ feedbackList }) {
  return (
    <>
      <Row>
        <Col sm="6">
          <ul className="feedbac_headlist">
            <li>
              <h5>Feedbacks</h5>
            </li>
            <li>
              <select className="newselect">
                <option>Recent</option>
              </select>
            </li>
          </ul>

          <div className="payment_graph">
            <div className="scroll-area shadow-overflowl dashscroll">
              <PerfectScrollbar>
                <div className="table-responsive">
                  <Table hover striped className="table_cust">
                    <thead className="thead_bg">
                      <th style={{ width: "40%" }} className="userth">
                        User Name
                      </th>
                      <th style={{ width: "40%" }} className="userth">
                        Feedback
                      </th>
                      <th style={{ width: "20%" }} className="userth">
                        Actions
                      </th>
                    </thead>

                    <tbody>
                      {feedbackList &&
                        feedbackList.length > 0 &&
                        feedbackList.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <ul className="dasboar_table_list">
                                  <li>
                                    <img src={item?.image} alt="" />
                                  </li>
                                  {/* <li>
                                                            <h5>Alexa</h5>
                                                        </li> */}
                                </ul>
                              </td>

                              <td>{item?.comment}</td>

                              <td>
                                <Button
                                  href="/feedbackmanagement"
                                  className="healcheck_btn"
                                >
                                  <img
                                    src={"/assets/images/eyeblue.svg"}
                                    className="healeyeblue"
                                    alt=""
                                  />
                                  <img
                                    src={"/assets/images/eyewhite.svg"}
                                    className="healeyewhite"
                                    alt=""
                                  />
                                  View
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </div>
              </PerfectScrollbar>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}
